import { CaptureOptions } from 'posthog-js';
import { useCallback } from 'react';
import { useLatest } from 'react-use';

import { useAnalytics } from './useAnalytics';

export const useCaptureEvent = (context: Record<string, unknown> = {}) => {
  const contextRef = useLatest(context);
  const analytics = useAnalytics();
  return useCallback(
    (
      eventName: string,
      properties: Record<string, unknown> = {},
      captureOptions?: CaptureOptions,
    ) => {
      analytics.capture(
        eventName,
        {
          ...contextRef.current,
          ...properties,
        },
        captureOptions,
      );
    },
    [contextRef, analytics],
  );
};
